import React, { Fragment } from "react";
import { connect } from "react-redux";
import Orders from "../components/tracker/Orders";
import OrdersCancelled from "../components/tracker/OrdersCancelled";
import OrdersBroken from "../components/tracker/OrdersBroken";
import { getTrackerInfo } from "../actions/trackerAction";
import Spinner from "../components/layout/Spinner";
import Tab from "react-bootstrap/Tab";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Badge from "react-bootstrap/Badge";
class TrackerContainer extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.getTrackerInfo();
  }
  render() {
    const { loading, trackerInfo } = this.props.trackerInfo;
    return (
      <Fragment>
        {loading ? (
          <Spinner />
        ) : (
          <Tab.Container
            mountOnEnter
            unmountOnExit
            className="mt-2"
            id="left-tabs-example"
            defaultActiveKey="orders"
          >
            <Row>
              <Col sm={2} className="pt-5">
                <Nav variant="tabs" className="flex-column">
                  <Nav.Item>
                    <Nav.Link eventKey="orders">
                      Orders{" "}
                      <Badge variant="light">{trackerInfo.orders.length}</Badge>
                    </Nav.Link>
                  </Nav.Item>
                  {trackerInfo.cancelled.length > 0 && (
                    <Nav.Item>
                      <Nav.Link eventKey="cancelled">
                        Cancelled{" "}
                        <Badge variant="light">
                          {trackerInfo.cancelled.length}
                        </Badge>
                      </Nav.Link>
                    </Nav.Item>
                  )}
                  {trackerInfo.broken.length > 0 && (
                    <Nav.Item>
                      <Nav.Link eventKey="broken">
                        Broken{" "}
                        <Badge variant="light">
                          {trackerInfo.broken.length}
                        </Badge>
                      </Nav.Link>
                    </Nav.Item>
                  )}
                </Nav>
              </Col>
              <Col sm={10}>
                <div className="container-fluid">
                  <Tab.Content>
                    <Tab.Pane eventKey="orders">
                      {trackerInfo.orders.length > 0 ? (
                        <Orders
                          orders={trackerInfo.orders}
                          fsas={trackerInfo.fsas}
                        />
                      ) : (
                        <h2 className="display-4 text-center">
                          There are no orders
                        </h2>
                      )}
                    </Tab.Pane>
                    <Tab.Pane eventKey="cancelled">
                      {trackerInfo.cancelled.length > 0 ? (
                        <OrdersCancelled
                          orders={trackerInfo.cancelled}
                          fsas={trackerInfo.fsas}
                        />
                      ) : (
                        <h2 className="display-4 text-center">
                          There are no cancelled orders
                        </h2>
                      )}
                    </Tab.Pane>
                    <Tab.Pane eventKey="broken">
                      {trackerInfo.broken.length > 0 ? (
                        <OrdersBroken
                          orders={trackerInfo.broken}
                          fsas={trackerInfo.fsas}
                        />
                      ) : (
                        <h2 className="display-4 text-center">
                          There are no broken orders
                        </h2>
                      )}
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Col>
            </Row>
          </Tab.Container>
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = ({ trackerInfo, user }) => ({
  trackerInfo: trackerInfo,
  user: user,
});
const mapDispatchToProps = (dispatch) => ({
  getTrackerInfo: (trackerInfo) => dispatch(getTrackerInfo(trackerInfo)),
});
export default connect(mapStateToProps, mapDispatchToProps)(TrackerContainer);
